export const bookmark = () => (
  <path
    d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2v16z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
